import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-betslip-panel"
}
const _hoisted_2 = { class: "mobile-betslip-header" }
const _hoisted_3 = { class: "mobile-betslip-title" }
const _hoisted_4 = { class: "mobile-betslip-content" }
const _hoisted_5 = { class: "desktop-modal-box" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "desktop-modal-content" }

import BetSlip from '@/components/BetSlip.vue'
import { iframeCommunication } from '@/utils/iframeCommunication';
import { ref, onMounted, onUnmounted, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BetslipModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isMobile = ref(false)

const checkMobile = () => {
  isMobile.value = window.matchMedia('(max-width: 768px)').matches
}

const isInIframe = iframeCommunication.isRunningInIframe()

// Prevent body scrolling when mobile panel is open (standalone only; iframe uses setMobileBetslipIframeOpen)
const preventBodyScroll = () => {
  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.width = '100%'
}

const restoreBodyScroll = () => {
  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.width = ''
}

const syncMobileBetslipScrollLock = (isOpen: boolean) => {
  if (isInIframe) {
    iframeCommunication.setMobileBetslipIframeOpen(isOpen && isMobile.value)
    return
  }

  if (!isMobile.value) {
    restoreBodyScroll()
    return
  }

  if (isOpen) {
    preventBodyScroll()
  } else {
    restoreBodyScroll()
  }
}

// Watch for mobile panel open/close
watch(() => props.isOpen, (isOpen) => {
  syncMobileBetslipScrollLock(isOpen)
})

watch(isMobile, () => {
  syncMobileBetslipScrollLock(props.isOpen)
})

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
  syncMobileBetslipScrollLock(false)
})

const close = () => emit('close')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isMobile.value && _ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "mobile-betslip-drawer-handle",
            "aria-hidden": "true"
          }, [
            _createElementVNode("span", { class: "mobile-betslip-drawer-bar" })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('betslip.title')), 1),
            _createElementVNode("button", {
              class: "mobile-close-button",
              onClick: close
            }, " × ")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BetSlip, { onClose: close })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "modal-slide-down" }, {
      default: _withCtx(() => [
        (!isMobile.value && _ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "desktop-modal-overlay",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "desktop-close-button",
                  type: "button",
                  "aria-label": _ctx.$t('betslip.closeBetslip'),
                  onClick: close
                }, " × ", 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(BetSlip, { onClose: close })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})